import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Phone, CalendarPlus } from 'lucide-react';
import { Section } from './Section';
import { BookingModal } from './BookingModal';
import { useLanguage } from './LanguageContext';
interface Barber {
  name: string;
  alias: string | null;
  phone: string;
  phoneRaw: string;
  image: string;
}
export function Barbers() {
  const [selectedBarber, setSelectedBarber] = useState<Barber | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    t
  } = useLanguage();
  const barbers: Barber[] = [{
    name: 'Jose Santana',
    alias: 'Ariel',
    phone: '(347) 605-8521',
    phoneRaw: '3476058521',
    image: 'https://cdn.magicpatterns.com/uploads/q9hXQrhtrw91BgHddkQget/ariel.jpg'
  }, {
    name: 'Janco',
    alias: null,
    phone: '(347) 785-1569',
    phoneRaw: '3477851569',
    image: 'https://cdn.magicpatterns.com/uploads/4W3prr2boF717ihDvn7fuh/el_firu.jpg'
  }, {
    name: 'George',
    alias: null,
    phone: '(917) 107-1071',
    phoneRaw: '9171071071',
    image: 'https://cdn.magicpatterns.com/uploads/nC6EVX3Y6DP23W1gavZxDk/companero_.jpg'
  }, {
    name: 'David',
    alias: 'Spana',
    phone: '(718) 414-9492',
    phoneRaw: '7184149492',
    image: 'https://cdn.magicpatterns.com/uploads/7afPTgrnBeBNjrcR2wuN9a/espana.jpg'
  }];
  function openBooking(barber: Barber) {
    setSelectedBarber(barber);
    setIsModalOpen(true);
  }
  return <Section className="bg-barber-black" data-id="element-62">
      <div className="text-center mb-16" data-id="element-63">
        <h2 className="font-heading text-4xl md:text-5xl font-bold text-barber-text uppercase mb-4" data-id="element-64">
          {t('barbers.heading1')}{' '}
          <span className="text-barber-gold" data-id="element-65">{t('barbers.heading2')}</span>
        </h2>
        <p className="text-barber-muted text-lg md:text-xl mt-4" data-id="element-66">
          {t('barbers.subtitle')}
        </p>
        <div className="w-16 h-1 bg-barber-gold mx-auto mt-4" data-id="element-67"></div>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-68">
        {barbers.map((barber, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.15
      }} className="bg-barber-gray border border-barber-lightGray rounded-sm overflow-hidden group hover:border-barber-gold/50 transition-colors cursor-pointer" onClick={() => openBooking(barber)} data-id="element-69">
            <div className="flex items-start gap-4 p-5" data-id="element-70">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-full overflow-hidden shrink-0 border-2 border-barber-gold/30" data-id="element-71">
                <img src={barber.image} alt={`${barber.name}${barber.alias ? ` (${barber.alias})` : ''} — Barbero en VillaConBarberShop`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-72" />
              </div>
              <div className="text-left" data-id="element-73">
                <p className="text-barber-gold font-heading text-xs tracking-widest uppercase" data-id="element-74">
                  {t('barbers.barberLabel')}
                </p>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-barber-text uppercase tracking-wide" data-id="element-75">
                  {barber.name}
                </h3>
                {barber.alias && <p className="text-barber-gold font-heading text-sm tracking-widest uppercase mt-1" data-id="element-76">
                    "{barber.alias}"
                  </p>}
                <a href={`tel:${barber.phoneRaw}`} onClick={e => e.stopPropagation()} className="inline-flex items-center gap-2 mt-2 text-barber-muted hover:text-barber-gold transition-colors text-sm md:text-base" data-id="element-77">
                  <Phone size={16} data-id="element-78" />
                  {barber.phone}
                </a>
                <div className="flex items-center gap-2 mt-3 text-barber-gold text-sm font-heading uppercase tracking-wider opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-79">
                  <CalendarPlus size={16} data-id="element-80" />
                  {t('barbers.bookHover')}
                </div>
              </div>
            </div>
          </motion.div>)}
      </div>
      <BookingModal barber={selectedBarber} isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-81" />
    </Section>;
}